import { render, staticRenderFns } from "./indexad-add-or-update.vue?vue&type=template&id=2c6b247c"
import script from "./indexad-add-or-update.vue?vue&type=script&lang=js"
export * from "./indexad-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./indexad-add-or-update.vue?vue&type=style&index=0&id=2c6b247c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports